import about from '@/api/about'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {}
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: 1
      },
      attrubutes
    )
    return about.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return about.store(data)
  },
  update(context, data) {
    return about.update(data)
  },
  aboutImageContent(context, data) {
    return about.aboutImageContent(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await about.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  }
}
